import { render, staticRenderFns } from "./_base-simpleDataTable.vue?vue&type=template&id=269636b3&scoped=true&"
import script from "./_base-simpleDataTable.vue?vue&type=script&lang=js&"
export * from "./_base-simpleDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269636b3",
  null
  
)

export default component.exports